import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
import { actionCreators as toursCategoriesActions } from '../../store/ToursCategories'
import ExternalIntegrationsApiService, { ExternalCategoryMappingModel, ExternalCategoryMappingPostModel } from '../../services/ExternalIntegrationsApiService'
import { DataTable, DataTableColumnModel, DataTableModel, FilterType, InputType, SelectOptionModel } from 'traveldesk-ui'
interface Props {
    apiProviderId: number | undefined
}

const AdminExternalCategoriesMappings = (props: Props) => {
    const dispatch = useDispatch()
    const toursCategoriesOptions = useSelector((state: ApplicationState) => state.toursCategories.options)
    const [externalCategories, setExternalCategories] = React.useState<ExternalCategoryMappingModel[]>([])
    const toursCategoriesHash = React.useMemo(() => {
        return toursCategoriesOptions.reduce((acc, curr) => {
            acc.set(curr.value as number, curr.label)
            return acc
        }, new Map<number, string>())
    }, [toursCategoriesOptions])
    React.useEffect(() => {
        dispatch(toursCategoriesActions.requestOptions())
    }, [])
    React.useEffect(() => {
        if (props.apiProviderId) {
            getCategories()
        }
    }, [props.apiProviderId])
    const getCategories = async () => {
        if (props.apiProviderId) {
            const categoriesResponse = await ExternalIntegrationsApiService.getExternalCategoriesMappings(dispatch, props.apiProviderId.toString())
            if (categoriesResponse.IsOk && categoriesResponse.Content) {
                setExternalCategories(categoriesResponse.Content)
            }
        }
    }
    const initDataTable = () => {
        const columns = [
            new DataTableColumnModel({
                displayName: 'API Integration Category',
                fieldName: 'apiIntegrationCategoryName',
                filterType: FilterType.TEXT,
            }),
            new DataTableColumnModel({
                displayName: 'Our Category',
                fieldName: 'ourCategoryId',
                isEditable: true,
                editType: InputType.Select,
                editOptions: toursCategoriesOptions,
                filterType: FilterType.SELECT,
                filterOptions: toursCategoriesOptions,
                isClearable: true,
                customRenderer: (obj: ExternalCategoryMappingModel) => obj.ourCategoryId ? toursCategoriesHash.get(obj.ourCategoryId as number) : ''
            })
        ]
        return new DataTableModel({
            columns,
            name: 'Categories Mappings',
        })
    }
    const onSetMapping = async (prevObj: ExternalCategoryMappingModel, obj: ExternalCategoryMappingModel) => {
        if (prevObj.ourCategoryId !== obj.ourCategoryId) {
            const payload = { apiProviderId: props.apiProviderId as number, categoryId: obj.ourCategoryId, externalCategoryId: obj.apiIntegrationCategoryId } as ExternalCategoryMappingPostModel
            const response = await ExternalIntegrationsApiService.saveExternalCategoriesMapping(dispatch, payload)
            if (response.IsOk && response.Content) {
                setExternalCategories(prevCategories => prevCategories.map(category => category.apiIntegrationCategoryId === obj.apiIntegrationCategoryId ? response.Content ?? category : category))
            }
        }
    }
    const onRefreshData = async () => {
        await getCategories()
    }
    return <DataTable
        data={externalCategories}
        dataTable={initDataTable()}
        onRefreshData={onRefreshData}
        isFullScreen
        fixedHeight={600}
        onEdit={onSetMapping} />
}
export default AdminExternalCategoriesMappings